import * as React from 'react';
import MuiAppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { StyledflexSpacebetween} from './Styled/index'
import history from '../Utility/history';
import { useSelector, useDispatch } from 'react-redux';
import { createRequestData, getDocumentAsBlobUrl, getRequestData, updateRequestData } from '../Utility/apiHelper';
import { privateRoutesPath } from '../Routes';
import { useSnackbar } from 'notistack';
import { requestHideLoader, requestShowLoader } from '../Store/Global/action';
import { requestLogout } from '../Store/User/action';
import Badge from '@mui/material/Badge';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import { Divider } from '@mui/material';
import moment from 'moment';
import CircleIcon from '@mui/icons-material/Circle';
import bticon from '../Assets/images/biztantu-logo-full.png';
import sampleImage from '../Assets/images/biztantu-logo-bt.png';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { handleValidateCodevalue } from '../Utility/constant';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { resolveNotificationRoute } from '../Utility/notificationRoute';
import { useIsMobile } from '../Utility/hooks/useIsMobile';
import LanguageIcon from '@mui/icons-material/Language';
import '../Assets/css/header.css';
import { resetTheme } from '../Utility/theme';
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";

const ResponsiveHeader = ({open, handleDrawerOpen, handleCloseOpenMiniDrawer, onOpenI18n}) => {
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [anchorElnotification, setAnchorElnotification] = React.useState(null);
   
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const rolebasedData = useSelector(state => state?.owner?.rolebasedData);
    const [currentRole, setCurrentRole] = React.useState("");
    const[inputsearchvalue, setinputsearchvalue] = React.useState("");
    const organizationLabel = useSelector(state => state?.owner?.organizationLabel);
    const [messageList, setmessageList] = React.useState([]);
    const intervalRef = React.useRef(null);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const [logoUrl, setLogoUrl] = React.useState(sampleImage);
    const [logoObjectUrl, setLogoObjectUrl] = React.useState(null);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const isMobile = useIsMobile();

    const fetchNotifications = async() => {
        if (!localStorage.getItem('accessToken')) return;

        const url = `${process.env.REACT_APP_BASE_URL}notification/all`;

        const { data } = await getRequestData(url);

        if (!data || !Array.isArray(data)) return;

        const sortedList = data?.sort((a,b) => moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf());

        setmessageList(sortedList);
    };
    React.useEffect(() => {
        const loadLogo = async () => {
            const docId = currentUser?.client?.logoPath;
            if (!docId) {
                setLogoUrl(sampleImage);
                return;
            }
            try {
                const url = await getDocumentAsBlobUrl(docId);
                setLogoUrl(url || sampleImage);
            } catch (err) {
                console.error("Error loading logo:", err);
                setLogoUrl(sampleImage);
            }
        };
        loadLogo();
    }, [currentUser?.client?.logoPath]);

    React.useEffect(() => {
        fetchNotifications();
        intervalRef.current = setInterval(() => { fetchNotifications(); }, process.env.REACT_APP_NOTIFICATION_INTERVAL);
        return () => { clearInterval(intervalRef.current); };
    }, [])

    React.useEffect(() => {
        if (!currentUser) {
            clearInterval(intervalRef.current);
        }
    }, [currentUser])

    React.useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                fetchNotifications();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    const {enqueueSnackbar} = useSnackbar();
    const dispatch = useDispatch();
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleOpenUserBell = (event) => {
        setAnchorElnotification(event.currentTarget);
    };

    const handleCloseUserBell = () => {
        setAnchorElnotification(null);
    };

    const handlemarkAsSeenAllNotification = async() => {
        const notificationsid = messageList?.filter(item => item?.seen == false)?.map(item => item?.id);

        const url = `${process.env.REACT_APP_BASE_URL}notification/markAsSeen`;

        if(notificationsid.length > 0) {

            const {data} = await updateRequestData(notificationsid,url);

            if(data) {
                fetchNotifications();
            }
           
        }

    }


    const handlemarkAnItemasSeen = async(item) => {

        const url = `${process.env.REACT_APP_BASE_URL}notification/markAsSeen`;

        const {data} = await updateRequestData([item?.id],url);

        const updatedMessageList = messageList.map(notificationitem => {
            if(notificationitem?.id == item?.id) {
                return {
                    ...notificationitem,
                    seen: true
                }
            }

            return notificationitem
        })?.sort((a,b) => moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf())

        setmessageList(updatedMessageList);
    }

    React.useEffect(() => {
        if(currentUser) {
            let specificRole = "";
            const isLeadOperator = currentUser?.authorities?.find(item => item?.authority == "ROLE_leadoperator");
            const isAdmin = currentUser?.authorities?.find(item => item?.authority == "ROLE_admin")
            if(isAdmin && isLeadOperator) {
                specificRole = "Admin";
            }
            if(isLeadOperator && !isAdmin) {
                specificRole = "Lead Operator"
            }
            setCurrentRole(specificRole);
        }
    },[currentUser])

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleLogOut = () => {
        resetTheme();
        clearInterval(intervalRef.current);
        dispatch(requestLogout());
        history.push('/');
    }

    const handleSearch = async() => {
        const searchreq = {
            "documentType" : "ALL",
            "searchWith" : {
                "any" : inputsearchvalue
            },
            "operator" : "OR"
        }

        dispatch(requestShowLoader());

        const url = `${process.env.REACT_APP_ELASTIC_SEARCH}search`;

        const responseData = await createRequestData(searchreq, url);

        if(responseData?.status == 'error') {
            history.push({pathname: `${privateRoutesPath.GLOBAL_SEARCH}`, state: {searchString: inputsearchvalue}});
            dispatch(requestHideLoader());
            dispatch(requestHideLoader());
        } else {
            history.push({pathname: `${privateRoutesPath.GLOBAL_SEARCH}`, state: {responseData: responseData }});
            dispatch(requestHideLoader());
        }
    }

    const rendersecondry = (item) => {
        return (
            <StyledflexSpacebetween className="header-noti-secondary-row">
                <Typography
                    variant='subtitle2'
                    className={item?.seen ? "" : "header-noti-bold"}
                >
                    {item?.messagePrefix}{' '}
                    {handleValidateCodevalue(internationalise,item?.message)}
                </Typography>
                <Typography
                    variant='subtitle2'
                    className={item?.seen ? "" : "header-noti-bold"}
                >
                    {moment(item?.createdAt).format("DD MMM YYYY, hh:mm A")}
                </Typography>
            </StyledflexSpacebetween>
        )
    }

    const rendertitle = (item) => {
        return (
            <StyledflexSpacebetween className="header-noti-title-row">
                <Typography
                    variant='subtitle2'
                    className={item?.seen ? "" : "header-noti-bold"}
                >
                    {item?.titlePrefix}{' '}
                    {handleValidateCodevalue(internationalise, item?.title)}
                </Typography>
                {!item?.seen && <Typography variant='subtitle2'>
                    <Tooltip title={handleValidateCodevalue(internationalise,"NOTI_MARK_AS_READ")}>
                        <CircleIcon
                            onClick={() => handlemarkAnItemasSeen(item)}
                            className="header-noti-circle-icon"
                        />
                    </Tooltip>
                </Typography>}
            </StyledflexSpacebetween>
        )
    }

    const location = useLocation();

    const handleOnClickNotification = (item) => {
        const route = resolveNotificationRoute(item);
        if (!route) return;

        handlemarkAnItemasSeen(item);

        history.push({
            pathname: route,
            state: { from: location.pathname },
        });
        handleCloseUserBell();
    };

    const handleNavigate = () => {
        history.push(`${privateRoutesPath.PROFILE}`);
        handleCloseUserMenu()
    }

    return (
        <MuiAppBar
            position="fixed"
            open={open}
            className={open ? "header-appbar header-appbar-open" : "header-appbar"}
        >
            <div className='header-container'>
                <Toolbar disableGutters>
                    <div className="header-toolbar-left">
                        {isMobile && <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleCloseOpenMiniDrawer}
                            edge="start"
                            className="header-hamburger-btn"
                        >
                            <MenuIcon />
                        </IconButton>}
                        <Box className={isMobile ? "header-logo-box-mobile" : "header-logo-box"}>
                            <div className='logo-container'>
                                <img src={bticon} />
                            </div>
                        </Box>
                    </div>

                    <Box className={isMobile ? "header-right-box-mobile" : "header-right-box"}>
                        <div className='logo-container'>
                            <img src={logoUrl} alt="org logo" />
                        </div>

                        {(!isMobile && specificRolePermission?.isConfigurationView) && (
                            <Tooltip title={handleValidateCodevalue(internationalise, "CONF_I18_PAGE_KEYS")}>
                                <IconButton
                                    size="small"
                                    onClick={onOpenI18n}
                                    className="header-i18n-btn padding-zero"
                                >
                                    <LanguageIcon className="secondary-color header-icons" />
                                </IconButton>
                            </Tooltip>
                        )}

                            <IconButton
                                onClick={handleOpenUserBell}
                                className = "padding-zero"
                                >
                        <Badge
                        variant="dot"
                        invisible={!messageList?.some(item => item.seen === false)}
                        className="header-notification-badge"
                        >
                        <NotificationsOutlinedIcon
                            className="secondary-color header-icons"
                        />
                        </Badge>
                        </IconButton>
                        <Menu
                            className="header-notification-menu"
                            id="notificatonlist"
                            anchorEl={anchorElnotification}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            PaperProps={{ className: "header-notification-paper" }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElnotification)}
                            onClose={handleCloseUserBell}
                        >
                            <List dense={true} className="header-notification-list">
                                {messageList?.length > 0 ? (messageList?.map(item => {
                                    return (
                                        <>
                                            <ListItem
                                                className={item?.seen ? "header-notification-item-seen" : "header-notification-item-unseen"}
                                            >
                                                <ListItemAvatar>
                                                    <Avatar className="header-notification-avatar">
                                                        {currentUser ? `${currentUser?.firstname?.[0]} ${currentUser?.lastname?.[0]}` : "L A"}
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText
                                                    onClick={() => handleOnClickNotification(item)}
                                                    primary={rendertitle(item)}
                                                    secondary={rendersecondry(item)}
                                                />
                                            </ListItem>
                                            <Divider />
                                        </>
                                    )
                                })) : (
                                    <Typography className="header-no-notifications">
                                        {handleValidateCodevalue(internationalise,'COMMON_NO_NOTIFICATIONS')}
                                    </Typography>
                                )}
                            </List>
                            <StyledflexSpacebetween className="header-mark-read-bar">
                                <Button onClick={handlemarkAsSeenAllNotification} variant="text">
                                    {handleValidateCodevalue(internationalise,'NOTI_MARK_AS_READ')}
                                </Button>
                            </StyledflexSpacebetween>
                        </Menu>

                        <Box onClick={handleOpenUserMenu} className="header-user-box">
                            <IconButton className="header-avatar-btn">
                                <Avatar className="header-avatar" alt="Remy Sharp">
                                    {currentUser ? `${currentUser?.firstname?.[0]} ${currentUser?.lastname?.[0]}` : "L A"}
                                </Avatar>
                            </IconButton>
                            <KeyboardArrowDownIcon className="header-arrow-down" />
                        </Box>

                        <Menu
                            className="header-user-menu"
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            {!isMobile && <MenuItem
                                onClick={handleNavigate}
                                className="header-profile-menuitem"
                                key='user-logout'
                            >
                                <Box className="header-profile-inner-box">
                                    <IconButton className="header-profile-avatar-btn">
                                        <Avatar className="header-avatar" alt="Remy Sharp">
                                            {currentUser ? `${currentUser?.firstname?.[0]} ${currentUser?.lastname?.[0]}` : "L A"}
                                        </Avatar>
                                    </IconButton>
                                    <Box className="header-profile-name-box">
                                        <Typography className="header-profile-name">
                                            {currentUser?.firstname} {currentUser?.lastname}
                                        </Typography>
                                        <Typography className="header-profile-email">
                                            {currentUser?.username}
                                        </Typography>
                                    </Box>
                                </Box>
                            </MenuItem>}

                            <MenuItem
                                className="header-logout-menuitem"
                                key='logout'
                                onClick={handleLogOut}
                            >
                                <Typography className="header-logout-text">
                                    {handleValidateCodevalue(internationalise,'HEADER_PROFILE_LOG_OUT')}
                                </Typography>
                            </MenuItem>
                        </Menu>
                    </Box>
                </Toolbar>
            </div>
        </MuiAppBar>
  );
};
export default ResponsiveHeader;